export const formDataEmployeeCreate = (defaultData?: Employee): FormParams => {
    return {
        items: {
            upperFields: [
                {
                    element: 'input',
                    type: 'text',
                    id: 'name',
                    placeHolder: 'Nome do funcionário',
                    label: 'Nome do funcionário',
                    defaultValue: defaultData ? defaultData.name : null,
                },
                {
                    element: 'input',
                    type: 'text',
                    id: 'email',
                    placeHolder: 'Email do funcionário',
                    label: 'Email do funcionário',
                    defaultValue: defaultData ? defaultData.email : null,
                },
                {
                    element: 'input',
                    type: 'password',
                    id: 'password',
                    placeHolder: 'Senha do funcionário',
                    label: 'Senha do funcionário',
                    defaultValue: null,
                },
                {
                    element: 'select',
                    id: 'role',
                    label: 'Função:',
                    options: [
                        {value: 'default', text: 'Selecionar'},
                        {value: 'Administrator', text: 'Administrator' },
                        {value: 'Teacher', text: 'Professor' },
                    ],
                    defaultValue: defaultData
                        ? defaultData.role
                        : null,
                },
            ],
            bottomFields: [],
        },
        style: 'gray',
    };
};
